export interface ModalLoading {
    text: string | "",
    show: boolean | false
}

export const modalLoadingState: ModalLoading = {
    text: "",
    show: false
};

export const loadingActionTypes = {
    SHOW_LOADING: "SHOW_LOADING",
    HIDE_LOADING: "HIDE_LOADING",
};

export const actions = {
    showLoading: (data: any) => ({ type: loadingActionTypes.SHOW_LOADING, ...data }),
    hideLoading: () => ({ type: loadingActionTypes.HIDE_LOADING }),
};

const modalLoadingReducer = (state = modalLoadingState, action: any) => {
    switch (action.type) {
        case loadingActionTypes.SHOW_LOADING:
            return {
                text: action.data.text,
                show: true,
            }
        case loadingActionTypes.HIDE_LOADING:
            return {
                text: "Loading...",
                show: false,
            }
        default:
            return { ...state }
    }
}

export { modalLoadingReducer }